<template>
	<form class="c-form-brief" @submit.prevent="onSubmit">
		<Form
			ref="form"
			:schema="schema"
			v-model="form"
			@status="saveStatus"
			buttonText="Create brief"
			:processing="processing"
			:errors="errors"
		></Form>
	</form>
</template>

<script>
import Form from './index.vue';
import {
	objectives,
	awareness,
	sophistication,
	frameworks,
} from '@swipekit/lib/brief-details';

const schema = {
	brandName: {
		component: 'InputText',
		label: '*Brand name',
		placeholder: 'eg, Nike',
		validations: {
			required: {
				params: null,
				message: 'This field is required',
			},
			maxLength: {
				params: 100,
				message: `That's a long brand name.`,
			},
		},
	},
	productName: {
		component: 'InputText',
		label: '*Product or Service name',
		placeholder: 'eg, Air Jordans',
		validations: {
			required: {
				params: null,
				message: 'This field is required',
			},
			maxLength: {
				params: 100,
				message: `That's a long product name.`,
			},
		},
	},
	objective: {
		component: 'InputRadioGroup',
		label: '*Ad objective',
		options: objectives,
		gridColumns: 1,
		validations: {
			required: {
				params: null,
				message: 'This field is required',
			},
		},
	},
	productDescription: {
		component: 'InputTextarea',
		label: '*Product description',
		validations: {
			required: {
				params: null,
				message: 'This field is required',
			},
		},
	},
	usp: {
		component: 'InputTextarea',
		label: 'Unique selling point',
	},
	offers: {
		component: 'InputTextarea',
		label: 'Running offers',
	},
	targetAudience: {
		component: 'InputTextarea',
		label: 'Target audience',
	},
	awareness: {
		component: 'InputRadioGroup',
		label: '*Awareness level',
		options: awareness,
		gridColumns: 1,
		validations: {
			required: {
				params: null,
				message: 'This field is required',
			},
		},
	},
	sophistication: {
		component: 'InputRadioGroup',
		label: 'Market sophistication level',
		options: sophistication,
		gridColumns: 1,
	},
};

export default {
	components: {
		Form,
	},

	data: function () {
		return {
			processing: false,
			schema: schema,
			form: {},
			errors: [],
			status: null,
		};
	},

	props: {
		brief: {},
	},

	methods: {
		saveStatus: function (saveStatus) {
			this.status = saveStatus;
		},
		async onSubmit() {
			this.$refs.form.validate();

			if (this.status.invalid) {
				return;
			}

			this.processing = true;

			let form = this.form;

			let obj = {
				...form,
			};

			let res = await this.$store.dispatch('briefs/add', obj).catch((err) => {
				if (err && err.response && err.response.status === 400) {
					console.log(err.response);

					if (
						err.response &&
						err.response.data &&
						err.response.data.length > 0
					) {
						this.errors = err.response.data;
					}
				} else {
					this.errors = [
						{
							message: err.message || 'Something went wrong.',
						},
					];
				}
			});

			if (res) {
				this.$emit('onSubmit', res);
			}

			this.processing = false;
		},
	},

	created: function () {
		if (this.brief) {
			this.form = {
				...this.brief,
			};
		}
		// this.form = {
		// 	brandName: 'Nike',
		// 	productName: 'sneakers',
		// 	objective: 'Awareness',
		// 	productDescription: 'pd',
		// 	usp: 'usp',
		// 	offers: 'running offers',
		// 	targetAudience: 'target audience',
		// 	sophistication: 'L5',
		// 	awareness: 'L5',
		// };
	},
};
</script>

<style lang="scss">
.c-form-brief {
	.c-input-textarea {
		.form-control {
			min-height: 100px;
		}
	}
}
</style>
